import React from 'react';
import { Quote } from 'lucide-react';
const testimonials = [{
  name: 'María C.',
  role: 'Ciencias Naturales primaria',
  location: 'Argentina',
  text: 'Las guías son clarísimas. Me ahorró muchísimo tiempo y las clases salen mejor.',
  color: 'bg-blue-50 border-blue-100'
}, {
  name: 'Jorge A.',
  role: 'Secundaria',
  location: 'Chile',
  text: 'Los experimentos simples fueron clave. Participan más y entienden mejor.',
  color: 'bg-green-50 border-green-100'
}, {
  name: 'Sandra R.',
  role: 'Primaria',
  location: 'México',
  text: 'Está súper organizado. Abrís una unidad y ya tenés todo listo.',
  color: 'bg-amber-50 border-amber-100'
}, {
  name: 'Luis P.',
  role: 'Secundaria',
  location: 'Colombia',
  text: 'Me encantaron las pautas de evaluación y las rúbricas. Mucho más fácil corregir.',
  color: 'bg-purple-50 border-purple-100'
}, {
  name: 'Ana M.',
  role: 'Ciencias',
  location: 'Perú',
  text: 'No es relleno. Es aplicable de verdad.',
  color: 'bg-rose-50 border-rose-100'
}];
export const Testimonials: React.FC = () => {
  return <section className="py-16 bg-white" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-166">
          Docentes que ya lo usan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-167">
          {testimonials.map((t, i) => <div key={i} className={`p-6 rounded-xl border ${t.color} relative`} data-id="element-168">
              <Quote className="w-8 h-8 text-gray-300 absolute top-4 right-4" data-id="element-169" />
              <p className="text-gray-700 mb-4 italic relative z-10" data-id="element-170">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-171">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-sm" data-id="element-172">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-173">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-174">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-175">
                    {t.role} • {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};